import { render, staticRenderFns } from "./CloseDialogButton.vue?vue&type=template&id=645493d4&scoped=true"
var script = {}
import style0 from "./CloseDialogButton.vue?vue&type=style&index=0&id=645493d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645493d4",
  null
  
)

export default component.exports